import type { ApplicationSettingTheme, DesignStyle, VariableADTvalue } from '@lighthouse/core'

import { getBackgroundStyle, getBorderStyle, getRadiusStyle, getShadowStyle, getTextColorStyle } from '../../utils'

export const getBlockDesignStyle = (
    design: DesignStyle | undefined,
    options: {
        appId: string
        theme: ApplicationSettingTheme
        hoverStyle?: { design?: DesignStyle }
        activeStyle?: { design?: DesignStyle }
        disabledStyle?: { design?: DesignStyle }
        onRenderLabel?: (value: VariableADTvalue | undefined) => string
    }
) => {
    const { onRenderLabel, hoverStyle, activeStyle, disabledStyle, appId, theme } = options
    // 常规
    const textColorStyle = getTextColorStyle(design?.color, theme.palettes)
    const backgroundStyle = getBackgroundStyle({
        appId,
        value: design?.background,
        palettes: theme.palettes,
        parseVariableImage: onRenderLabel,
        cssSuffix: '!important'
    })
    const borderStyle = getBorderStyle(design?.border, theme.palettes, '!important')
    const radiusStyle = getRadiusStyle(design?.radius)
    const shadowStyle = getShadowStyle(design?.shadow, theme.palettes)

    /* 悬浮态(单独) start */
    const hoverTextColorStyle = getTextColorStyle(hoverStyle?.design?.color, theme.palettes)
    const hoverBackgroundStyle = getBackgroundStyle({
        appId,
        value: hoverStyle?.design?.background,
        palettes: theme.palettes,
        parseVariableImage: onRenderLabel,
        cssSuffix: '!important'
    })
    const hoverBorderStyle = getBorderStyle(hoverStyle?.design?.border, theme.palettes, '!important')
    const hoverRadiusStyle = getRadiusStyle(hoverStyle?.design?.radius)
    const hoverShadowStyle = getShadowStyle(hoverStyle?.design?.shadow, theme.palettes)
    /* 悬浮态(单独) end */

    /* 选中态(单独) start */
    const activeTextColorStyle = getTextColorStyle(activeStyle?.design?.color, theme.palettes)
    const activeBackgroundStyle = getBackgroundStyle({
        appId,
        value: activeStyle?.design?.background,
        palettes: theme.palettes,
        parseVariableImage: onRenderLabel,
        cssSuffix: '!important'
    })
    const activeBorderStyle = getBorderStyle(activeStyle?.design?.border, theme.palettes, '!important')
    const activeRadiusStyle = getRadiusStyle(activeStyle?.design?.radius)
    const activeShadowStyle = getShadowStyle(activeStyle?.design?.shadow, theme.palettes)
    const activeCheckedColorStyle = getTextColorStyle(activeStyle?.design?.checkedColor, theme.palettes).color
    /* 选中态(单独) end */

    /* 禁用态(单独) start */
    const disabledTextColorStyle = getTextColorStyle(disabledStyle?.design?.color, theme.palettes)
    const disabledBackgroundStyle = getBackgroundStyle({
        appId,
        value: disabledStyle?.design?.background,
        palettes: theme.palettes,
        parseVariableImage: onRenderLabel,
        cssSuffix: '!important'
    })
    const disabledRadiusStyle = getRadiusStyle(disabledStyle?.design?.radius)
    const disabledBorderStyle = getBorderStyle(disabledStyle?.design?.border, theme.palettes, '!important')
    const disabledShadowStyle = getShadowStyle(disabledStyle?.design?.shadow, theme.palettes)
    /* 禁用态(单独) end */

    return {
        textColorStyle,
        backgroundStyle,
        borderStyle,
        radiusStyle,
        shadowStyle,

        hoverTextColorStyle,
        hoverBackgroundStyle,
        hoverBorderStyle,
        hoverRadiusStyle,
        hoverShadowStyle,

        activeTextColorStyle,
        activeBackgroundStyle,
        activeBorderStyle,
        activeCheckedColorStyle,
        activeRadiusStyle,
        activeShadowStyle,

        disabledTextColorStyle,
        disabledBackgroundStyle,
        disabledBorderStyle,
        disabledRadiusStyle,
        disabledShadowStyle
    }
}
